import React from 'react';

/**
 * DeptFilter (C2 / FT7) — the department grouping control.
 *
 * PURELY client-side + presentational: it is a controlled <select> whose change
 * only lifts the chosen dept id to the page (which re-GROUPS via selectDeptGroups
 * — tagged wards pinned, everything else still shown). Switching it NEVER fires a
 * network request (Cost-LOCKED: the board is one read, the dept view is a
 * client regroup) and NEVER removes a ward. Default is "All departments" and the
 * choice is NOT persisted.
 *
 * Per-dept totals (from the shared selector's `perDept` rollup) render ONLY when
 * a department is active — there is never an additive Σ row across departments.
 */
export default function DeptFilter({ options = [], value = '', onChange, deptStats = null }) {
  return (
    <div className="flex items-center gap-2">
      <select
        aria-label="Department filter"
        data-testid="dept-filter"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="rounded-lg border border-slate-300 bg-white px-2.5 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100"
      >
        <option value="">All departments</option>
        {options.map((o) => (
          <option key={o.id} value={o.id}>{o.name}</option>
        ))}
      </select>

      {value && deptStats && (
        <span
          data-testid="dept-totals"
          className="rounded-full bg-teal-50 px-2.5 py-1 text-xs font-semibold text-teal-800 dark:bg-teal-900/40 dark:text-teal-100"
        >
          {deptStats.byState?.OCCUPIED ?? 0}/{deptStats.total ?? 0} occupied in this department
        </span>
      )}
    </div>
  );
}
